import {
  degreeDaysRecord,
  larvalTrendRecord,
  phenologyRecord,
  trapCatchesRecord,
} from 'stores/selectedValueGroupsStore/insectValueGroupRecords'
import type { TValueGroup } from 'stores/selectedValueGroupsStore/selectedValueGroupsStore'

export const includeNdviSwitch: Record<TValueGroup, boolean> = {
  air_temperature: true,
  almond_bloom: true,
  almond_hull_split: true,
  alternaria: true,
  atmospheric_pressure: true,
  bee_hours: true,
  cherry_powdery_mildew: true,
  chill: true,
  conditions: true,
  ...degreeDaysRecord(() => true),
  dew_point: true,
  equipment_status: false,
  evapotranspiration: true,
  fire_blight: true,
  fruit_growth: true,
  grape_powdery_mildew: true,
  plant_stress: true,
  humidity: true,
  irrigation_activity_pressure: true,
  irrigation_activity_zones: true,
  irrigation_activity_flow_meters: true,
  ...larvalTrendRecord(() => true),
  leaf_wetness: true,
  precipitation: true,
  soil: true,
  spray_conditions: true,
  ...trapCatchesRecord(() => true),
  ...phenologyRecord(() => false),
  wet_bulb: true,
  wind: true,
  wind_machine: true,
  ndvi: true,
}
